import styled from 'styled-components';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const ActionsMenuGroup = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const ActionsMenuButton = styled.button`
  ${Mixins.transition('background-color')};
  background: none;
  display: block;
  margin: 0;
  border: 0;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  cursor: pointer;
  width: 100%;
  padding-left: 51px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-right: 21px;
  text-align: left;
  color: ${(p) => p.color};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  outline: none;

  &:hover {
    background-color: ${Colors.ivory};
  }
`;

export const ActionsMenuItem = styled.div`
  background: none;
  margin: 0;
  border: 0;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  width: 100%;
  padding-left: 51px;
  padding-top: 15px;
  padding-bottom: 15px;
  text-align: left;
`;

export const ActionsMenu = styled.div`
  min-width: 240px;
  background-color: ${Colors.white};
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  box-shadow: 0 0 34px 6px rgba(97, 108, 121, 0.13), -1px 1px 2px 0 rgba(97, 108, 121, 0.2);
  border-radius: 10px;
`;

export const ActionsMenuToggleButton = styled.button`
  border: none;
  background: transparent;
  font-size: 20px;
  color: ${Colors.nobel};
  padding: 0;
  width: 26px;
  height: 24px;
  line-height: 0.8;
  outline: none;
  cursor: pointer;
  border-radius: 50%;

  &:hover {
    background-color: ${Colors.whisper};
  }
`;
